import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { IntegrationsApiAdapter } from '../adapters/IntegrationsApiAdapter';

export const CHATBY_TOKEN_QUERY_KEY = 'chatby-token';

export const useChatbyToken = (enabled = true) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegrationsApiAdapter(httpClient);

  return useQuery({
    queryKey: [CHATBY_TOKEN_QUERY_KEY],
    queryFn: () => adapter.getChatbyToken(),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      if ((error as { statusCode?: number }).statusCode === 403) return false;
      return failureCount < 2;
    },
  });
};
